import React, { useState } from 'react';
import api from "../../../../services/api";
const PermissionForm = ({onClose}) =>{
    const [permissionName, setPermissionName] = useState('');
    const [permissionCode, setPermissionCode] = useState('');
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const handleSubmit = async (event) =>{
        event.preventDefault();
        setLoading(true);
         setError(null)
        try{
          await api.post('/roles/permissions', {name: permissionName, code: permissionCode})
           onClose();
        } catch(error){
            console.error('Ошибка при создании прав:', error)
           setError('Ошибка при создании прав')
       } finally {
            setLoading(false)
         }
    }
  return (
      <div style={{position:'fixed', top:'0', left:'0', right:'0', bottom:'0', backgroundColor:'rgba(0,0,0,0.5)', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <div style={{background:'white', padding:'20px', borderRadius:'8px', width:'500px'}}>
                <h2>Создание права</h2>
                {error && <div style={{color:'red'}}>{error}</div>}
                 <form onSubmit={handleSubmit}>
                     <input
                         type="text"
                         placeholder="Название права"
                         value={permissionName}
                         onChange={(e) => setPermissionName(e.target.value)}
                         style={{marginBottom:'10px', padding: '8px', width:'100%', border: '1px solid #ccc', borderRadius: '4px'}}
                         />
                     <input
                         type="text"
                         placeholder="Код права"
                         value={permissionCode}
                         onChange={(e) => setPermissionCode(e.target.value)}
                         style={{marginBottom:'10px', padding: '8px', width:'100%', border: '1px solid #ccc', borderRadius: '4px'}}
                     />

                     <div style={{display:'flex', justifyContent: 'space-between'}}>
                         <button type="submit" style={{padding: '10px 15px', backgroundColor: '#4caf50', color:'white', border:'none', borderRadius:'4px', cursor: 'pointer'}} disabled={loading}>{loading ? 'Отправка...' : 'Создать'}</button>
                         <button type="button" onClick={onClose} style={{padding: '10px 15px', backgroundColor: '#f44336', color:'white', border:'none', borderRadius:'4px', cursor: 'pointer'}}>Отмена</button>
                    </div>
                 </form>
          </div>
      </div>
  )
}
export default PermissionForm;
